import { formatCurrency } from "@helpers";

import { mapGetters } from "vuex";

export default {
  methods: {
    formatInvoiceCurrency (value) {
      return formatCurrency(value, this.invoiceCurrency.iso_code);
    }
  },

  computed: {
    ...mapGetters("lineItemsTable", [
      "invoiceCurrency"
    ])
  }
};
